import {FC, useEffect, useState} from 'react';
import {useTranslation} from 'react-i18next';
import {useField} from 'formik';
import {List} from '@tickchak/react-share/app';
import {TShow} from '../../../../../hooks/useShow';
import {useTimetableDays} from '../../../hooks/useTimetableDays';
import DayListItem from '../../dayListItem/DayListItem';
import BackArrow from '../../../../../assets/icons/BackArrow';

interface DaySelectPopupProps {
    show: TShow;
}

const DaySelectPopup: FC<DaySelectPopupProps> = ({show}) => {
    const {t} = useTranslation('timetable');
    const {conferenceDays} = useTimetableDays();
    const [field, , helpers] = useField<number>('dayIndex');
    const [, , tsidHelpers] = useField<number | null>('tsid');
    const [draftIndex, setDraftIndex] = useState<number>(field.value);

    useEffect(() => {
        if(show.isOpen) setDraftIndex(field.value);
    }, [show.isOpen, field.value]);

    if(!show.isOpen) return null;

    const handleConfirm = () => {
        if(draftIndex !== field.value) {
            tsidHelpers.setValue(draftIndex === -1 ? 0 : null);
        }
        helpers.setValue(draftIndex);
        show.close();
    };

    return (
        <List
            show={show}
            data-cy="daySelectPop"
            position={{width: '375px', height: '432px'}}
            ariaLabel={t('selectDayTitle')}
        >
            <List.Header
                fixed
                title={t('selectDayTitle')}
                onBack={() => show.close()}
                backIcon={<BackArrow />}
            />
            <List.Items>
                {conferenceDays.map((day, i) => (
                    <List.Item.Custom key={day.timestamp} id={String(i)}>
                        <DayListItem
                            label={day.label}
                            count={day.count}
                            selected={i === draftIndex}
                            onClick={() => setDraftIndex(i)}
                            data-cy={`daySelect-${i}`}
                        />
                    </List.Item.Custom>
                ))}
                <List.Item.Custom id="no-date">
                    <DayListItem
                        label={t('noDateLectures')}
                        selected={draftIndex === -1}
                        onClick={() => setDraftIndex(-1)}
                        data-cy="daySelect-no-date"
                    />
                </List.Item.Custom>
            </List.Items>
            <List.Footer fixed>
                <List.Footer.Close text={t('close')} size="category" />
                <List.Footer.Button
                    text={t('confirm')}
                    variant="brand"
                    size="category"
                    onClick={handleConfirm}
                />
            </List.Footer>
        </List>
    );
};

export default DaySelectPopup;
